import React, { useMemo, useState } from 'react';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useSelectorContext } from './SelectorContext';

import styles from './CapabilitySelector.module.scss';
import { useStandardCollator } from 'js/utils/string';
import { Icon } from 'js/components';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import CapabilitySet from './CapabilitySet';

function CapabilityTree() {
  const { selectedCapabilities, capabilitySets } = useSelectorContext();

  const collator = useStandardCollator();
  const sortedCapabilitySets = useMemo(() => {
    return capabilitySets?.sort(
      (a, b) => collator.compare(a.name, b.name) || collator.compare(a.id, b.id)
    );
  }, [capabilitySets, collator]);

  const [includedSets, setIncludedSets] = useState({});

  const handleIncludeSet = (event) => {
    setIncludedSets({
      ...includedSets,
      [event.target.value]: true,
    });
  };

  const { chosenSets, remainingSets } = useMemo(() => {
    const uniqueSets = new Set();

    Object.values(selectedCapabilities).forEach((c) => {
      if (c !== true) {
        uniqueSets.add(c);
      }
    });

    return sortedCapabilitySets.reduce(
      (acc, cs) => {
        if (!includedSets[cs.id] && !uniqueSets.has(cs.id)) {
          acc.remainingSets.push(cs);
        } else {
          acc.chosenSets.push(cs);
        }

        return acc;
      },
      { chosenSets: [], remainingSets: [] }
    );
  }, [sortedCapabilitySets, includedSets, selectedCapabilities]);

  return (
    <div>
      <div className={styles['capability-set-adder']}>
        <UncontrolledDropdown className={styles['capability-set-dropdown']}>
          <DropdownToggle className="btn-inline">
            <Icon icon={faPlus} className="icon-left" /> Set
          </DropdownToggle>
          <DropdownMenu container="body" className={styles['escape']}>
            {remainingSets?.map((cs) => (
              <DropdownItem
                onClick={handleIncludeSet}
                key={cs.id}
                value={cs.id}
              >
                {cs.name}
              </DropdownItem>
            ))}
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
      {chosenSets.map((cs) => (
        <CapabilitySet key={cs.id} capabilitySet={cs} />
      ))}
    </div>
  );
}

export default CapabilityTree;
